import React from 'react'
import './Antiaging.css'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const antiagingFAQs = [
  {
    question: 'At what age should I start anti-aging treatments?',
    answer:
      "There's no fixed age — some people start preventive care in their late 20s, while others begin once fine lines or sagging become noticeable, usually in their 30s or 40s.",
  },
  {
    question: 'Are anti-aging treatments painful?',
    answer: 'Most treatments cause only mild, temporary discomfort. Numbing options are available for procedures that may feel more intense.',
  },
  {
    question: 'How long do results last?',
    answer:
      'This depends on the specific treatment — some effects last several months, while a combination approach with maintenance sessions helps sustain results longer.',
  },
  {
    question: 'Is there downtime after anti-aging treatments?',
    answer: 'Many treatments have little to no downtime, though some procedures may cause mild redness or swelling for a day or two.',
  },
]

const Antiaging = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='antihero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Anti-Aging Treatments
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Best Anti Ageing Treatment in Pitampura | Skin Rejuvenation clinic in Delhi
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best anti ageing treatment in Pitampura? Get advanced skin rejuvenation treatments like fillers, microneedling and
                laser therapy for glowing skin.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Anti Ageing Treatment in Pitampura</h2>
              <p>
                Aging is a natural process, but modern aesthetic treatments make it possible to maintain healthy, youthful-looking skin for longer.
                Fine lines, wrinkles, sagging skin, and dull complexion are common concerns that appear with time due to reduced collagen production
                and environmental factors.
              </p>
              <p>
                At a professional skin clinic, the <span style={{ fontWeight: 'bold' }}>best anti-aging treatment in Pitampura</span> focuses on
                restoring skin elasticity, improving texture, and reducing visible signs of aging through advanced dermatological procedures.
              </p>
              <p>Modern anti-ageing solutions are non-surgical, safe, and designed to enhance natural beauty while improving overall skin health.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What is Anti Ageing Treatment?</h3>
              <p>
                Anti ageing treatment refers to a group of cosmetic procedures designed to slow down or reduce visible signs of aging. These
                treatments stimulate collagen production, improve skin hydration, and restore lost facial volume.
              </p>
              <p>Common skin concerns treated include:</p>
              <ul>
                <li>Fine lines and wrinkles</li>
                <li>Loose or sagging skin</li>
                <li>Uneven skin tone</li>
                <li>Loss of facial volume</li>
                <li>Dull or tired-looking skin</li>
              </ul>
              <p>Many advanced procedures today are minimally invasive and allow patients to return to their daily routine quickly.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Popular Anti Ageing Treatments Available in Pitampura</h3>
              <p>Several advanced procedures are commonly used to restore youthful skin:</p>
              <p>
                <span style={{ fontWeight: 'bold' }}>Dermal Fillers</span>
                <br />
                Dermal fillers restore lost volume in areas like cheeks, under-eyes, and lips, reducing deep wrinkles and improving facial contours.
              </p>
              <p>
                <span style={{ fontWeight: 'bold' }}>Microneedling</span>
                <br />
                Microneedling stimulates collagen production by creating tiny micro-channels in the skin, improving skin texture and reducing fine
                lines.
              </p>
              <p>
                <span style={{ fontWeight: 'bold' }}>Laser Skin Rejuvenation</span>
                <br />
                Laser treatments target damaged skin layers and stimulate new collagen growth, improving skin firmness and reducing pigmentation.
              </p>
              <p>
                <span style={{ fontWeight: 'bold' }}>HIFU Skin Tightening</span>
                <br />
                HIFU (High-Intensity Focused Ultrasound) is a non-surgical treatment that lifts sagging skin and improves elasticity without downtime.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Anti Ageing Treatments</h3>
              <p>
                Choosing the <span style={{ fontWeight: 'bold' }}>best anti ageing treatment in Pitampura</span> can offer multiple benefits:
              </p>
              <ul>
                <li>Reduction of wrinkles and fine lines</li>
                <li>Improved skin firmness and elasticity</li>
                <li>Brighter and healthier skin tone</li>
                <li>Enhanced collagen production</li>
                <li>Improved facial contours</li>
                <li>Natural and youthful appearance</li>
              </ul>
              <p>These treatments are customized according to skin type and ageing concerns.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Who Should Consider Anti Ageing Treatment?</h3>
              <p>
                Anti ageing treatments are ideal for individuals who want to improve skin quality and delay visible aging signs. They are commonly
                recommended for people experiencing:
              </p>
              <ul>
                <li>Early wrinkles and fine lines</li>
                <li>Loss of facial volume</li>
                <li>Sagging skin</li>
                <li>Uneven skin texture</li>
                <li>Pigmentation and dullness</li>
              </ul>
              <p>A consultation with a cosmetic specialist helps determine the most suitable procedure for each individual.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Cost of Anti Ageing Treatment in Delhi</h3>
              <p>
                The cost of anti-aging treatments varies depending on the procedure and technology used. In Delhi, the average cost may range from{' '}
                <span style={{ fontWeight: 'bold' }}>₹3,000</span> to <span style={{ fontWeight: 'bold' }}>₹50,000</span> per session, depending on
                the treatment type and clinic expertise.
              </p>
              <p>For example:</p>
              <ul>
                <li>Chemical Peels: ₹3,000 – ₹10,000</li>
                <li>Dermal Fillers: ₹8,000 – ₹25,000</li>
                <li>Laser Treatments: ₹8,000 – ₹30,000</li>
                <li>HIFU Skin Tightening: ₹15,000 – ₹50,000</li>
              </ul>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Why Choose a Professional Clinic for Anti Ageing Treatment?</h3>
              <p>A reputable aesthetic clinic provides:</p>
              <ul>
                <li>Advanced dermatology technology</li>
                <li>Personalized treatment plans</li>
                <li>Safe and hygienic procedures</li>
                <li>Experienced cosmetic specialists</li>
                <li>Natural-looking results</li>
              </ul>
              <p>Professional guidance ensures that the treatment matches your skin needs and delivers long-lasting improvement.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Get the best anti-aging treatment in Pitampura</h3>
              <p>
                If you want to maintain youthfull, radiant skin, choosing{' '}
                <span style={{ fontWeight: 'bold' }}>the best anti-aging treatment in Pitampura</span> can help reduce wrinkles , tighten skin, and
                restore natural glow.
              </p>
              <p>
                Modern skin rejuvenation procedures focus on improving skin health while enhanching natural beauty, helping you acieve smoother and
                firmer skin with minmal downtime.
              </p>

              <ServiceDoctorInfo
                name='Dr. Sweta Mishra'
                specialty='Maxillofacial Aesthetic Surgeon'
                education='MDS, FAM, Dip. in Aesthetic Medicine'
                image={doc_img}
                blurb='Dr. Sweta Mishra designs anti-aging treatment plans at Sharva Clinique combining non-surgical procedures for natural, long-lasting rejuvenation.'
                profileLink='/anti-aging-treatment'
              />

              <ServiceFAQ title='FAQs - Anti-Aging Treatment' faqs={antiagingFAQs} />
            </div>
          </div>
        </div>
        <div className='asthmareview'>
          <p
            className=''
            style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#85553D',
              fontFamily: 'inherit',
            }}
          >
            What Our Patients Say
          </p>
          <div className='card1'>
            <p>“I love how natural my skin looks. No heavy or ‘done’ appearance, just refreshed and youthful. Highly recommend.”</p>
            <p> — Seema </p>
          </div>
          <div className='card2'>
            <p>
              “Effective treatments and a caring team. I appreciate how they explained everything and helped me choose the right options for my skin.”
            </p>
            <p>— Neha </p>
          </div>
          <div className='card3'>
            <p>“Noticeably smoother skin in just a few sessions. Worth every visit.”</p>
            <p> — Kavita </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Antiaging
